export const DATES_REQUEST_ALREADY_EXISTS_CODE = 'dates_request_already_exists'
export const DATES_REQUEST_OUTSIDE_POLICY_CODE = 'dates_request_outside_policy'
export const DATES_REQUEST_OUTSIDE_POLICY_NOT_AVAILABLE_CODE = 'dates_request_outside_policy_not_available'
export const AUTO_EXTEND_NOT_AVAILABLE_CODE = 'auto_extend_not_available'
